/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ArrowUpDoubleLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m12 4.84-6.2 6.2 1.4 1.42 4.8-4.8 4.8 4.8 1.4-1.42zm0 5.65-6.2 6.2 1.4 1.42 4.8-4.8 4.8 4.8 1.4-1.42z" />
  </Icon>
);
